import { EnumDayOfWeek } from '@types';

export const STATUSES = ['Active', 'Suspended', 'Deleted'];

export const DAYS_OF_WEEK = [
    EnumDayOfWeek.MONDAY,
    EnumDayOfWeek.TUESDAY,
    EnumDayOfWeek.WEDNESDAY,
    EnumDayOfWeek.THURSDAY,
    EnumDayOfWeek.FRIDAY,
    EnumDayOfWeek.SATURDAY,
    EnumDayOfWeek.SUNDAY,
];
